import { registerEnum } from '@cbbt/lib-interface';
var IdvSkippedReason;
(function (IdvSkippedReason) {
    IdvSkippedReason["CONTINUED_ON_DESKTOP"] = "CONTINUED_ON_DESKTOP";
    IdvSkippedReason["PASSPORT_COUNTRY_NOT_APPROVED_FOR_ID_VERIFY"] = "PASSPORT_COUNTRY_NOT_APPROVED_FOR_ID_VERIFY";
    IdvSkippedReason["REFUSED_BIOMETRIC"] = "REFUSED_BIOMETRIC";
    IdvSkippedReason["REQUIRED_ID_DOC_UNAVAILABLE"] = "REQUIRED_ID_DOC_UNAVAILABLE";
})(IdvSkippedReason || (IdvSkippedReason = {}));
registerEnum(IdvSkippedReason, 'IdvSkippedReason');
export { IdvSkippedReason };
//# sourceMappingURL=IdvSkippedReason.js.map